import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';
import { useAuthStore } from '../stores/authStore';
import { LIVE_POLL, LIVE_STALE_MS, livePollInterval } from '../config/liveSync';

const getConversationId = (conversation) =>
  conversation?.id || conversation?._id || '';

export const getPreviewProduct = (conversation) =>
  conversation?.contextProduct ||
  conversation?.product ||
  conversation?.attachedProducts?.[0] ||
  null;

const getProductId = (conversation) => {
  const product = getPreviewProduct(conversation);
  if (!product) return '';
  if (typeof product === 'string') return product;
  return product.id || product._id || '';
};

export const useConversations = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const query = useQuery({
    queryKey: ['conversations'],
    queryFn: async () => {
      const response = await apiService.getConversations();
      if (response.status === 'success' && response.data) {
        const list = Array.isArray(response.data)
          ? response.data
          : response.data.conversations || [];
        return list;
      }
      return [];
    },
    enabled: !!isAuthenticated,
    staleTime: LIVE_STALE_MS,
    refetchOnWindowFocus: true,
    refetchInterval: () => livePollInterval(LIVE_POLL.BADGE),
    placeholderData: (previous) => previous,
  });

  return {
    conversations: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
    getConversationId,
    getProductId,
    getPreviewProduct,
  };
};

export default useConversations;
